<mat-card id="case-detailed-results-editable">
    <mat-card-content *ngIf="result">

        <!-- FIRST ROW -->
        <div class="row">

            <!-- FIRST ROW - FIRST COLUMN -->
            <div class="col-sm-8">

                <div class="row mb-5">

                    <!-- GRAPHIC -->
                    <div class="col-sm-6">
                        <div class="row no-gutters dr-blue-thick-round-bordered pt-4">
                            <div class="col-12">
                                <result-graphic [claimAmount]="graphicClaimAmount"
                                                [replacementAmount]="graphicReplacementAmount"
                                                [reducedAmount]="graphicReducedAmount"
                                                [salvageAmount]="graphicSalvageAmount">
                                </result-graphic>
                            </div>
                        </div>
                    </div>

                    <!-- CALCULATION RESULT -->
                    <div class="col-sm-6">
                        <div class="row no-gutters">
                            <div class="col-12">
                                <div class="smp-title mb-3"> {{ 'detailed_processing.results.title.calculation_result' | translate }}</div>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12 dr-flex-wrapper">
                                <strong>{{ result.calculation.trans.costs_repair_net | translate }}</strong>
                                <span class="fill-remaining-space"></span>
                                <span>{{ result.calculation.costs_repair_net | drCurrency }}</span>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12 dr-flex-wrapper">
                                <strong>{{ result.calculation.trans.costs_repair_tax | translate }}</strong>
                                <span class="fill-remaining-space"></span>
                                <span>{{ result.calculation.costs_repair_tax | drCurrency }}</span>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12 dr-flex-wrapper">
                                <strong>{{ result.calculation.trans.costs_repair_gross | translate }}</strong>
                                <span class="fill-remaining-space"></span>
                                <span>{{ result.calculation.costs_repair_gross | drCurrency }}</span>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12 dr-flex-wrapper">
                                <strong>{{ result.calculation.trans.deductions | translate }}</strong>
                                <span class="fill-remaining-space"></span>
                                <span>{{ result.calculation.deductions | drCurrency }}</span>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12 dr-flex-wrapper">
                                <strong>{{ result.calculation.trans.appreciation | translate }}</strong>
                                <span class="fill-remaining-space"></span>
                                <span>{{ result.calculation.appreciation | drCurrency }}</span>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12 dr-flex-wrapper">
                                <strong>{{ result.calculation.trans.claims_amount_net | translate }}</strong>
                                <span class="fill-remaining-space"></span>
                                <span>{{ result.calculation.claims_amount_net | drCurrency }}</span>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12 dr-flex-wrapper">
                                <strong>{{ result.calculation.trans.claims_amount_tax | translate }}</strong>
                                <span class="fill-remaining-space"></span>
                                <span>{{ result.calculation.claims_amount_tax | drCurrency }}</span>
                            </div>
                        </div>

                        <div class="row no-gutters mb-2">
                            <div class="col-12 dr-flex-wrapper">
                                <strong>{{ result.calculation.trans.claims_amount_gross | translate }}</strong>
                                <span class="fill-remaining-space"></span>
                                <span>{{ result.calculation.claims_amount_gross | drCurrency }}</span>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12">
                                <span>{{ result.calculation.comment }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">

                    <!-- RESULT OVERVIEW -->
                    <div class="col-sm-6">
                        <div class="row no-gutters">
                            <div class="col-12 mb-3">
                                <div class="smp-title"> {{ 'detailed_processing.results.title.overview' | translate }} </div>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12 dr-flex-wrapper">
                                <strong>{{ result.general.trans.assessment_id | translate }}</strong>
                                <span class="fill-remaining-space"></span>
                                <span>{{ (selectedTotalLossAssessment ? selectedTotalLossAssessment.trans : '-') | translate }}</span>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12 dr-flex-wrapper">
                                <strong>{{ result.general.trans.duration_repair | translate }}</strong>
                                <span class="fill-remaining-space"></span>
                                <span>{{ result.general.duration_repair ? (result.general.duration_repair + ' ' + (result.general.trans.duration_repair_unit | translate)) : '-' }}</span>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12 dr-flex-wrapper">
                                <strong>{{ result.general.trans.duration_replacement | translate }}</strong>
                                <span class="fill-remaining-space"></span>
                                <span>{{ result.general.duration_replacement ? (result.general.duration_replacement + ' ' + ('common.label.days' | translate)) : '-' }}</span>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12 dr-flex-wrapper">
                                <strong>{{ result.general.trans.deductible_fullcoverage | translate }}</strong>
                                <span class="fill-remaining-space"></span>
                                <span>{{ result.general.deductible_fullcoverage | drCurrency }}</span>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12 dr-flex-wrapper">
                                <strong>{{ result.general.trans.deductible_partialcoverage | translate }}</strong>
                                <span class="fill-remaining-space"></span>
                                <span>{{ result.general.deductible_partialcoverage | drCurrency }}</span>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12 dr-flex-wrapper">
                                <strong>{{ result.general.trans.repair_approval | translate }}</strong>
                                <span class="fill-remaining-space"></span>
                                <span>{{ booleanAsTranslation(result.general.repair_approval) | titlecase }}</span>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12 dr-flex-wrapper">
                                <strong>{{ result.general.trans.notice_of_assignment | translate }}</strong>
                                <span class="fill-remaining-space"></span>
                                <span>{{ booleanAsTranslation(result.general.notice_of_assignment) | titlecase }}</span>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12 dr-flex-wrapper">
                                <strong>{{ result.general.trans.tax_percentage | translate }}</strong>
                                <span class="fill-remaining-space"></span>
                                <span>{{ result.general.tax_percentage ? result.general.tax_percentage + ' %' : '-' }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- VALUATION RESULT  -->
                    <div class="col-sm-6">
                        <div class="row no-gutters">
                            <div class="col-12">
                                <div class="smp-title mb-3"> {{ 'detailed_processing.results.title.valuation_result' | translate }} </div>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12 dr-flex-wrapper">
                                <strong>{{ result.valuation.trans.valuation_type | translate }}</strong>
                                <span class="fill-remaining-space"></span>
                                <span>{{ result.valuation.result_type ? result.valuation.result_type : '-' }}</span>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12 dr-flex-wrapper">
                                <strong>{{ result.valuation.trans.tax_type_id | translate }}</strong>
                                <span class="fill-remaining-space"></span>
                                <span>{{ result.valuation.tax_type ? result.valuation.tax_type : '-' }}</span>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12 dr-flex-wrapper">
                                <strong>{{ result.valuation.trans.net | translate }}</strong>
                                <span class="fill-remaining-space"></span>
                                <span>{{ result.valuation.net | drCurrency }}</span>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12 dr-flex-wrapper">
                                <strong>{{ result.valuation.trans.tax | translate }}</strong>
                                <span class="fill-remaining-space"></span>
                                <span>{{ result.valuation.tax | drCurrency }}</span>
                            </div>
                        </div>

                        <div class="row no-gutters mb-2">
                            <div class="col-12 dr-flex-wrapper">
                                <strong>{{ result.valuation.trans.gross | translate }}</strong>
                                <span class="fill-remaining-space"></span>
                                <span>{{ result.valuation.gross | drCurrency }}</span>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12">
                                <span>{{ result.valuation.comment }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <!-- STILL FIRST ROW - SECOND COLUMN - FURTHER RESULTS -->

            <div class="col-sm-4">
                <div class="row no-gutters">
                    <div class="col-12">
                        <div class="smp-title mb-3"> {{ 'detailed_processing.results.title.further_results' | translate }} </div>
                    </div>
                </div>

                <div class="row no-gutters mb-4" *ngFor="let furtherResult of result.additions">
                    <div class="col-12">

                        <div class="row no-gutters mb-2">
                            <div class="col-12">
                                <span class="smp-title-small">{{ furtherResult.result_type }}</span>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12 dr-flex-wrapper">
                                <strong>{{ furtherResult.trans.net | translate }}</strong>
                                <span class="fill-remaining-space"></span>
                                <span>{{ furtherResult.net | drCurrency }}</span>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12 dr-flex-wrapper">
                                <strong>{{ furtherResult.trans.tax | translate }}</strong>
                                <span class="fill-remaining-space"></span>
                                <span>{{ furtherResult.tax | drCurrency }}</span>
                            </div>
                        </div>

                        <div class="row no-gutters mb-2">
                            <div class="col-12 dr-flex-wrapper">
                                <strong>{{ furtherResult.trans.gross | translate }}</strong>
                                <span class="fill-remaining-space"></span>
                                <span>{{ furtherResult.gross | drCurrency }}</span>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12">
                                <span>{{ furtherResult.comment }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </mat-card-content>
</mat-card>
